import React, { Component, Fragment, createRef } from "react";
import { withRouter } from "react-router-dom";
import Dropzone from "react-dropzone";
import moment from "moment";
import Header from "../Header";
import WebNotif from "../../components/WebNotif";
import img from "../../assets/image/designer_icon/Upload-files-here.png";
import { urlapiEPE, urlEPEImage } from "../../config/urlapi";

var obj = new WebNotif();

class AdditionalChallanSubmission extends Component {
  constructor(props) {
    super(props);
    this.challanInput = createRef();
    this.submissionDateRef = createRef();
    this.state = {
      loading: false,
      isLoading: false,
      image64: null,
      imageFile: null,
      currentFileTypeofData: "",
      currentFileNameofData: "",
      submissionDate: "",
      refno: "",
      netcourseprice: "0",
      additionalChallanData: JSON.parse(
        localStorage.getItem("additionalChallanData") || "null"
      ),
    };
  }

  componentDidMount() {
    const additionalData = this.state.additionalChallanData;
    if (!additionalData) {
      obj.createNotification("error", "No additional challan request found.");
      this.props.history.push("/EPECustom");
      return;
    }
    this.setState({
      refno:
        additionalData?.additionalChallanVoucherNo ||
        additionalData?.voucherNo ||
        "",
      netcourseprice:
        additionalData?.additionalChallanAmount || additionalData?.pecFee || "0",
    });
  }

  verifyImageFile = (files) => {
    if (files && files.length > 0) {
      const currentFile = files[0];
      const currentFileType = currentFile.type;
      const currentFileSize = currentFile.size;
      if (currentFileSize > 2e6) {
        obj.createNotification("error", "File should be less than 2mbs, Try Again");
        return false;
      }
      if (
        ![
          "image/x-png",
          "image/png",
          "image/jpg",
          "image/jpeg",
          "image/gif",
          "application/pdf",
        ].includes(currentFileType)
      ) {
        obj.createNotification(
          "error",
          "This file type is not allowed, Images and PDF are allowed"
        );
        return false;
      }
      return true;
    }
  };

  handleOnDropImage = (files, rejectedFiles) => {
    if (rejectedFiles && rejectedFiles.length > 0) {
      this.verifyImageFile(rejectedFiles);
    }
    if (files && files.length > 0) {
      if (this.verifyImageFile(files)) {
        const currentFile = files[0];
        this.setState({ imageFile: currentFile });
        const reader = new FileReader();
        reader.addEventListener(
          "load",
          () => {
            this.setState({ image64: reader.result });
          },
          false
        );
        reader.readAsDataURL(currentFile);
        this.setState({
          currentFileTypeofData: currentFile.type,
          currentFileNameofData: currentFile.name,
        });
      }
    }
  };

  removeImage = () => {
    this.setState({
      image64: null,
      currentFileTypeofData: "",
      currentFileNameofData: "",
    });
  };

  handleSubmissionDate = (e) => {
    this.setState({ submissionDate: e.target.value });
  };

  downloadAdditionalChallanPDF = async () => {
    try {
      const additionalData = this.state.additionalChallanData;
      if (!additionalData?.challan_slip) {
        obj.createNotification("error", "Additional challan file not found.");
        return;
      }
      const voucherNumber =
        additionalData?.additionalChallanVoucherNo || additionalData?.voucherNo;
      const response = await fetch(urlEPEImage + additionalData.challan_slip);
      if (!response.ok) {
        throw new Error("Unable to download challan");
      }
      const blob = await response.blob();
      const downloadLink = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = `challan_${voucherNumber}.pdf`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      obj.createNotification("error", "Failed to download additional challan.");
    }
  };

  submitAdditionalChallan = async () => {
    if (this.state.image64 === null) {
      return obj.createNotification("error", "Challan image is required");
    }
    const additionalData = this.state.additionalChallanData || {};
    const reduxEpeForm = JSON.parse(localStorage.getItem("reduxEpeForm") || "{}");
    const reservedUserData = JSON.parse(
      localStorage.getItem("User_Data_Reserve") || "{}"
    );
    const fallbackCnic =
      reduxEpeForm?.form?.cnic ||
      reduxEpeForm?.form?.CNIC ||
      reservedUserData?.CNIC ||
      reservedUserData?.cnic ||
      "";
    const normalizedCnic = String(fallbackCnic).replace(/-/g, "").trim();
    const examId =
      localStorage.getItem("getLatestExamId") || reduxEpeForm?.form?.examId || "";

    const payload = {
      normalizedCnic,
      examId,
      challanNumber:
        additionalData?.additionalChallanVoucherNo ||
        additionalData?.voucherNo ||
        this.state.refno,
      paymentImage: this.state.image64,
      submissionDate: this.state.submissionDate,
    };

    try {
      this.setState({ loading: true });
      const response = await fetch(`${urlapiEPE}/cpd/submit-additional-challan`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const responseData = await response.json();
      if (!response.ok) {
        throw new Error(responseData?.message || "Failed to submit challan");
      }
      obj.createNotification(
        "success",
        responseData?.message || "Additional challan submitted successfully."
      );
      localStorage.removeItem("isAdditionalChallanFlow");
      localStorage.removeItem("additionalChallanData");
      this.props.history.push("/EPECustom");
    } catch (error) {
      obj.createNotification(
        "error",
        error?.message || "Failed to submit additional challan."
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    return (
      <Fragment>
        <Header />
        <div className="mtb-25 payment-container" style={{ padding: "20px" }}>
          <h3 className="text-center ptb-30 bold payment_heading">Additional Challan Submission</h3>
          <h5 className="text-center mt-3 co_g20A84C font-weight-bold font-16 mb-4">
            Step: Download and Submit Paid Challan
          </h5>
          <div className="container mt-40 text-center">
            <button
              type="button"
              className="btn admin_btn_default bold text-capitalize"
              style={{ width: "220px" }}
              onClick={this.downloadAdditionalChallanPDF}
            >
              Download Challan
            </button>
          </div>

          <div className="container mt-4">
            <div className="row mtb-15">
              <div className="col-md-3">
                <label style={{ fontWeight: "bold" }}>Total Amount</label>
                <div>Rs. {this.state.netcourseprice}</div>
              </div>
              <div className="col-md-3">
                <label style={{ fontWeight: "bold" }}>Challan No</label>
                <input
                  ref={this.challanInput}
                  type="text"
                  className="form-control"
                  value={this.state.refno}
                  disabled
                />
              </div>
              <div className="col-md-3">
                <label style={{ fontWeight: "bold" }}>Date of Submission</label>
                <input
                  type="date"
                  className="form-control"
                  ref={this.submissionDateRef}
                  value={this.state.submissionDate}
                  onChange={this.handleSubmissionDate}
                  min={moment(new Date("01/01/2020")).format("YYYY-MM-DD")}
                  max={moment(new Date()).format("YYYY-MM-DD")}
                />
              </div>
            </div>
          </div>

          <div className="container mt-40 text-center">
            <b>Upload your paid challan (image/pdf)</b>
          </div>
          <div className="container mt-3">
            <div className="col-md-6 offset-md-3 file_upload_admin ptb_4v ">
              {this.state.image64 !== null &&
              this.state.currentFileTypeofData.match("image.*") ? (
                <div onClick={this.removeImage} className="pointer text-center">
                  <img
                    style={{ height: "300px", width: "300px", objectFit: "cover" }}
                    src={this.state.image64}
                    alt="Challan"
                  />
                </div>
              ) : this.state.image64 !== null &&
                this.state.currentFileTypeofData === "application/pdf" ? (
                <div onClick={this.removeImage} className="pointer text-center">
                  <i className="far fa-file-pdf fa-3x pb-10" />
                  <div>
                    <i
                      className="fa fa-times-circle preview-close-icon fa-lg"
                      style={{ color: "#20A84C" }}
                    />
                  </div>
                </div>
              ) : null}

              {this.state.image64 == null && (
                <Dropzone
                  name="dropzone1"
                  onDrop={this.handleOnDropImage}
                  maxSize={1e7}
                  thumbnailWidth={300}
                  thumbnailHeight={300}
                >
                  {({ getRootProps, getInputProps, isDragActive }) => (
                    <section>
                      <div className="text-center" {...getRootProps()}>
                        <input name="myFiles" {...getInputProps()} />
                        <img
                          src={img}
                          className="height_7v mtb-10"
                          alt="Upload"
                        />
                        <h5 className="mb_unset">
                          {isDragActive
                            ? "Drop Image/PDF File Here!"
                            : "Upload paid challan image/pdf (max 2MB)"}
                        </h5>
                      </div>
                    </section>
                  )}
                </Dropzone>
              )}
            </div>
          </div>

          <div className="row col_margin mt-40 mb-40 ">
            <div className="d-flex justify-content-end mt-4 mb-4" style={{ width: "95%" }}>
              <button
                type="button"
                className="btn admin_btn_default bold float-right text-capitalize"
                style={{ width: "220px" }}
                onClick={this.submitAdditionalChallan}
                disabled={this.state.loading}
              >
                Submit Challan
              </button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(AdditionalChallanSubmission);
